import React, { useContext } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from '../../../components/layout';
import { SvgIconContainer } from '../../../components/icons';
import { draftStore } from '../../../store';
import { selectTeam, deselectTeam, selectAll, deselectAll } from '../../../actions/options';
import { OutlineButton } from '../../../components/buttons';
import { useMediaQuery } from 'react-responsive';
import { mobileBreakpoint } from '../../../lib';

const SelectButton = styled(OutlineButton)`
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    text-transform: none;
    opacity: ${props => props.disabled ? '0.6' : '1'};
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
`

const TeamItem = styled(Col)`
    position: relative;
    cursor: pointer;
    height: 60px;
    flex: 0 0 calc(25% - 10px);
    background-color: #161718;
    color: #eaebec;
    border-bottom: ${props => props.isSelected ? '3px solid #d6001c' : '3px solid transparent'};
    margin: 0 0 10px 10px;
    transition: border-bottom 0.25s, background-color 0.25s;
    align-items: center;
    &:hover {
        background-color: #262729;
        border-bottom: 3px solid #d6001c;
    }
    @media (max-width: 850px) {
        flex: 0 0 calc(33% - 10px);
    }
    @media (max-width: 900px) {
        flex: 0 0 calc(100% - 10px);
    }
    /*@media (max-width: 455px) {
        flex: 0 0 calc(100% - 10px);
    }*/
`

const TeamLogo = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt
}))`
    width: 50px;
    height: 60px;
    padding: 0px 0px 0px 30px;
`;

const TeamName = styled.span`
    padding-left: 15px;
`;

const H3 = styled.h3`
    text-transform: none;
    font-size: 16px;
    @media(max-width: 900px){
        font-size: 14px;
    }
`

function Header() {
    const { state:{teams, options: { year }} , dispatch } = useContext(draftStore);
    const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });
    return (
        <Row justifyContent="space-between" alignItems="flex-start">
            <Col>
                <H3>Select the team(s) you'll be drafting for:</H3>
            </Col>
            <Col alignSelf="center">
                {!isMobile && <>
                <SelectButton margin="0 20px 0 0" padding="0 0 0 0px" onClick={() => dispatch(selectAll(teams.data.map(x => x.code)))} disabled={year !== '2025'}>Select All</SelectButton>
                <SelectButton onClick={() => dispatch(deselectAll())} disabled={year !== '2025'}>Deselect All</SelectButton>
                </>}
            </Col>
        </Row>
    )
}

function TeamCard({ code, name, logo, isSelected, year }) {
    const { dispatch } = useContext(draftStore);
    const onClick = year === '2025' ? (isSelected ? () => dispatch(deselectTeam(code)) : () => dispatch(selectTeam(code))) : () => 1;
    return (
        <TeamItem onClick={onClick} isSelected={isSelected}>
            <SvgIconContainer show={isSelected}>
                <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1">
                    <path d="M0 0L36 0L0 36L0 0Z" id="Rectangle" fill="#D6001C" stroke="none" />
                    <g id="Icons/icon-32-circle-check" transform="translate(5.333496 6)">
                        <path d="M0 4.12836L3.57865 8L11 0" id="Path-2" fill="none" stroke="#FFFFFF" strokeWidth="2"/>
                    </g>
                </svg>
            </SvgIconContainer>
            <TeamLogo src={logo}/>
            <TeamName>{name}</TeamName>
        </TeamItem>
    )
}

function TeamList() {
    const { state } = useContext(draftStore);
    const { options: {selectedTeams, year}, teams: {data} } = state;
    return (
        <Container>
            <Row margin="0 0 -10px -10px" autoWidth>
                {data.map((team) => {
                    const isSelected = selectedTeams.some(selected => selected === team.code);
                    return (
                        <TeamCard
                            key={team.code}
                            code={team.code}
                            name={team.name}
                            logo={team.logo}
                            year={year}
                            isSelected={isSelected}
                        />
                    )
                })}
            </Row>
        </Container>
    )
}

function TeamSelectionList(){

    return (
        <>
            <Header />
            <TeamList />
        </>
    )
}

export default TeamSelectionList;